import React from 'react';
export default function Inline(props) {
  var children = props.children;
  var childCount = React.Children.toArray(children).length;
  if (!childCount) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0");
  }
  return children;
}